import { render, staticRenderFns } from "./c_color_picker.vue?vue&type=template&id=398e6af1&scoped=true"
import script from "./c_color_picker.vue?vue&type=script&lang=js"
export * from "./c_color_picker.vue?vue&type=script&lang=js"
import style0 from "./c_color_picker.vue?vue&type=style&index=0&id=398e6af1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398e6af1",
  null
  
)

export default component.exports